import { render } from "./SwitcherSection.vue?vue&type=template&id=000688f0"
import script from "./SwitcherSection.vue?vue&type=script&lang=js"
export * from "./SwitcherSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__